module.exports = __webpack_public_path__ + "img/icon-sb-coupon-color-boutique-white-24x24.70bfa45.svg";